module.exports = ":host{color:#232833}:host .modal-header{padding:15px 15px 0;border-bottom:0}:host .modal-body{padding:0 50px}:host .modal-body h4{margin:0 0 15px;font-weight:600}:host .modal-footer{padding:35px 15px;border-top:0;text-align:center}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/approval-popup/approval-popup.component.scss
// module id = 1235
// module chunks = 0